import React from 'react';

import { Paper, Tab, Tabs } from '@mui/material';

import { useDealInformationTabCounts } from './DealInformationTabCounts';
import DealInformationTabLabel from './DealInformationTabLabel';
import { DEAL_INFORMATION_TABS } from './constants';
import type { DealInformationTab } from './types';

interface Props {
  activeTab: DealInformationTab;
  onTabChange: (tab: DealInformationTab) => void;
}

export default function DealInformationToolbar({ activeTab, onTabChange }: Props) {
  const counts = useDealInformationTabCounts();

  return (
    <Paper sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
      <Tabs
        allowScrollButtonsMobile
        scrollButtons="auto"
        value={activeTab}
        variant="scrollable"
        onChange={(_event, value: DealInformationTab) => onTabChange(value)}
      >
        {DEAL_INFORMATION_TABS.map((tab) => (
          <Tab
            key={tab.value}
            label={<DealInformationTabLabel count={counts[tab.value]} label={tab.label} />}
            value={tab.value}
          />
        ))}
      </Tabs>
    </Paper>
  );
}
